import { render, staticRenderFns } from "./AddShangbiao.vue?vue&type=template&id=105af690&scoped=true"
import script from "./AddShangbiao.vue?vue&type=script&lang=js"
export * from "./AddShangbiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105af690",
  null
  
)

export default component.exports